import { Routes } from '@angular/router';
import { LocationRegionComponent } from './location-region.component';
import { LocationRegionCategoryComponent } from './location-region-category/location-region-category.component';


export const LocationRegionRoute: Routes = [
  {
    path: ':string',
    component: LocationRegionComponent
  },
  {
    path: ':string/:string',
    component: LocationRegionCategoryComponent
  },
];